import ActivateCampaign from "./ActivateCampaign";

export default ActivateCampaign;
